import React, { useState, useEffect } from "react";
import { LayoutEdicion, Edicion as EdicionContainer } from "..";
import secureLocalStorage from "react-secure-storage";

export default function EditAnimation({ slug }) {
  const [jugada, setJugada] = useState(null);
  const [usuario, setUserId] = useState();
  let playId = window.location.pathname.replace("/app/edit-animation/", "");
  let user = secureLocalStorage.getItem("userLocal");

  useEffect(() => {
    if (user.plays[playId]) setJugada(user?.plays[playId]);
  }, [user]);

  return (
    <LayoutEdicion>
      {jugada !== null ? (
        <EdicionContainer
          jugada={jugada}
          playId={playId}
          userId={usuario}
          isEdit={true}
        />
      ) : null}
    </LayoutEdicion>
  );
}

export async function getServerSideProps({ res, params }) {
  const { slug } = params;
  return { props: { slug } };
}
